import { render, staticRenderFns } from "./ParsedText.vue?vue&type=template&id=6e28b224&"
import script from "./ParsedText.vue?vue&type=script&lang=js&"
export * from "./ParsedText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports